import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  FormBuilder,
  FormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  Validators
} from "@angular/forms";
import {MatInput} from "@angular/material/input";

import {TranslateService} from "@ngx-translate/core";

import {BaseComponent} from "@shared/components/base-component";

@Component({
  selector: 'dsm-link-name',
  templateUrl: './link-name.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: LinkNameComponent,
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: LinkNameComponent,
      multi: true
    }
  ]
})
export class LinkNameComponent extends BaseComponent implements ControlValueAccessor, OnInit, AfterViewInit, OnDestroy {

  private readonly minLengthErrorKey = 'minlength';
  private readonly maxLengthErrorKey = 'maxlength';

  private fieldIsRequiredErrorMessage = '';
  private minLengthErrorMessage = '';
  private maxLengthErrorMessage = '';

  private readonly requiredErrorKey = 'required';

  @ViewChild('name') input?: MatInput;

  nameCtrl = new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(50)]);

  form = this.formBuilder.group({
    name: this.nameCtrl,
  });

  constructor(
    private formBuilder: FormBuilder,
    private translateService: TranslateService
  ) {
    super();
    this.setTranslations();
  }

  ngOnDestroy(): void {
    this.unsubscribeAll();
  }

  ngAfterViewInit(): void {
    this.input?.focus();
  }

  onChange: any = () => {
  }

  onTouched: any = () => {
  }

  writeValue(obj: any): void {
    this.form.controls.name.setValue(obj);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  validate({ value }: FormControl) {
    const isNotValid = this.nameCtrl.invalid;
    const result = isNotValid && {
      invalid: true
    };
    console.warn(JSON.stringify(result));
    return result;
  }

  ngOnInit(): void {
    this.addToUnsubscribe(
      this.form.controls.name.valueChanges.subscribe(newValue => {
        this.onChange(newValue);
      }));
  }

  getErrorMessageElementId(controlName: string, control: AbstractControl): string {
    let errorName = '';

    if (control.hasError(this.requiredErrorKey))
      errorName = this.requiredErrorKey;
    else if (control.hasError(this.minLengthErrorKey))
      errorName = this.minLengthErrorKey;
    else if (control.hasError(this.maxLengthErrorKey))
      errorName = this.maxLengthErrorKey;

    return `${controlName}-error-${errorName}`;
  }

  getErrorMessage(control: AbstractControl): string {
    if (control.hasError(this.requiredErrorKey))
      return this.fieldIsRequiredErrorMessage;

    if (control.hasError(this.minLengthErrorKey))
      return this.minLengthErrorMessage;

    if (control.hasError(this.maxLengthErrorKey))
      return this.maxLengthErrorMessage;

    return "";
  }

  private setTranslations() {
    this.translateService.get('errors.field-is-required').subscribe(t => this.fieldIsRequiredErrorMessage = t);
    this.translateService.get('errors.min-X-characters', {min: 3}).subscribe(t => this.minLengthErrorMessage = t);
    this.translateService.get('errors.max-X-characters', {max: 50}).subscribe(t => this.maxLengthErrorMessage = t);
  }

}
